import Container from '@admin/components/container'
import ModalPanel from '@admin/components/modal_panel'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import Criteria from './criteria'
import React from 'react'

class Overview extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    flash: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    code: PropTypes.string,
    entity: PropTypes.string,
    fields: PropTypes.array,
    filters: PropTypes.array,
    system: PropTypes.array,
    onChange: PropTypes.func,
    onChoose: PropTypes.func,
    onClose: PropTypes.func,
    onEdit: PropTypes.func,
    onNew: PropTypes.func,
    onPop: PropTypes.func,
    onPush: PropTypes.func
  }

  state = {
    active: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleClose = this._handleClose.bind(this)
  _handleDelete = this._handleDelete.bind(this)
  _handleNew = this._handleNew.bind(this)

  render() {
    const { entity, system } = this.props
    const shared = this._getShared()
    const owned = this._getOwned()
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-criteria-list-overview">
          <div className="maha-criteria-list-items">
            <div className="maha-criteria-list-section">
              <T text="t(System Filters)" />
            </div>
            <div className={ this._getClass(null) } onClick={ this._handleChoose.bind(this, null) }>
              <div className="maha-criteria-list-item-label">
                All { _.capitalize(pluralize(entity)) }
              </div>
            </div>
            { system && system.map((filter, index) => (
              <div className={ this._getClass(`system_${index}`) } key={`system_${index}`} onClick={ this._handleChoose.bind(this, `system_${index}`) }>
                <div className="maha-criteria-list-item-label">
                  <T text={ filter.title } />
                </div>
              </div>
            )) }
            { shared.length > 0 &&
              <div className="maha-criteria-list-section">
                <T text="t(Shared Filters)" />
              </div>
            }
            { shared.map((filter, index) => (
              <div className={ this._getClass(`shared_${index}`) } key={`filter_${index}`} onClick={ this._handleChoose.bind(this, `shared_${index}`) }>
                <div className="maha-criteria-list-item-label">
                  { filter.title }
                </div>
              </div>
            ))}
            <div className="maha-criteria-list-section">
              <T text="t(Your Filters)" />
            </div>
            { owned && owned.map((filter, index) => (
              <div className={ this._getClass(`filter_${index}`) } key={`filter_${index}`} onClick={ this._handleChoose.bind(this, `filter_${index}`) }>
                <div className="maha-criteria-list-item-label">
                  { filter.title }
                </div>
                <Button { ...this._getEdit(filter) } />
                <Button { ...this._getDelete(filter) } />
              </div>
            )) }
            <div className="maha-criteria-list-item">
              <Button { ...this._getNew() } />
            </div>
          </div>
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    this.props.onChange(null)
  }

  componentDidUpdate(prevProps, prevState) {
    const { active } = this.state
    if(active !== prevState.active) {
      const filter = this._getActive()
      const criteria = filter ? filter.config.criteria : null
      this.props.onChoose(criteria)
    }
  }

  _getActive() {
    const { active } = this.state
    const { system } = this.props
    const owned = this._getOwned().find((filter, index) => {
      return `filter_${index}` === active
    })
    if(owned) return owned
    const shared = this._getShared().find((filter, index) => {
      return `shared_${index}` === active
    })
    if(shared) return shared
    return system.find((filter, index) => {
      return `system_${index}` === active
    })
  }

  _getClass(id) {
    const { active } = this.state
    const classes = ['maha-criteria-list-item']
    if(id === active) classes.push('active')
    return classes.join(' ')
  }

  _getCriteria(filter = null) {
    const { code, fields, onChange } = this.props
    return {
      code,
      filter,
      fields,
      onChange,
      onCancel: this._handleCancel
    }
  }

  _getDelete(filter) {
    return {
      icon: 'trash-o',
      className: 'maha-criteria-list-item-action',
      confirm: 't(Are you sure you want to delete this filter?)',
      request: {
        method: 'DELETE',
        endpoint: `/api/admin/${filter.code}/filters/${filter.id}`,
        onSuccess: this._handleDelete
      }
    }
  }

  _getEdit(filter) {
    return {
      svg: 'pencil',
      className: 'maha-criteria-list-item-action',
      handler: this._handleEdit.bind(this, filter)
    }
  }

  _getNew() {
    return {
      label: '+ t(New Filter)',
      className: 'maha-criteria-list-item-label',
      handler: this._handleNew
    }
  }

  _getOwned() {
    const { admin } = this.context
    const { filters } = this.props
    return filters.filter(filter => {
      return filter.owner.id === admin.user.id
    })
  }

  _getPanel() {
    return {
      title: 't(Filters)'
    }
  }

  _getShared() {
    const { admin } = this.context
    const { filters } = this.props
    return filters.filter(filter => {
      return filter.owner.id !== admin.user.id
    })
  }

  _handleCancel(reset) {
    if(reset) this._handleReset()
    this.props.onPop()
  }

  _handleClose() {
    this.props.onClose()
  }

  _handleDelete() {
    this._handleReset()
  }

  _handleChoose(active) {
    this.setState({ active })
  }

  _handleNew() {
    this._handleReset()
    this.props.onPush(Criteria, this._getCriteria.bind(this))
  }

  _handleEdit(filter) {
    this._handleChoose(filter.id)
    this.props.onPush(Criteria, this._getCriteria.bind(this, filter))
  }

  _handleReset() {
    const active = null
    this.props.onChange(active)
    this.setState({ active })
  }

}

const mapResources = (props, context) => ({
  filters: `/api/admin/${props.code}/filters`
})

export default Container(mapResources)(Overview)
